import * as React from 'react'
import { usePreviousProps } from '../../hooks/usePrevious'
import { BadgeProps } from './Badge'

export interface UseBadgeParameters {
  badgeContent?: React.ReactNode
  invisible?: boolean
  max?: number
  showZero?: boolean
  variant?: BadgeProps['variant']
}

export default function useBadge(parameters: UseBadgeParameters) {
  const {
    badgeContent: badgeContentProp,
    invisible: invisibleProp = false,
    max: maxProp = 99,
    showZero = false,
    variant,
  } = parameters

  const prevProps: Partial<UseBadgeParameters> = usePreviousProps({
    badgeContent: badgeContentProp,
    max: maxProp,
  })

  let invisible = invisibleProp

  if (
    invisibleProp === false &&
    ((badgeContentProp === 0 && !showZero) ||
      (badgeContentProp == null && variant !== 'dot'))
  ) {
    invisible = true
  }

  const { badgeContent, max = maxProp } = invisible ? prevProps : parameters

  const displayValue: React.ReactNode =
    badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent

  return {
    badgeContent,
    invisible,
    max,
    displayValue,
  }
}
